export const GET_AUTH = '[auth] Get auth token';
export const PROCESS_AUTH = '[auth] Process auth token';
export const AUTH_ERROR = '[auth] Error';
export const CLEAR_REFILL_STORE = '[auth] Clear and refill the store';

export const getAuth = (username, password) => ({
  type: GET_AUTH,
  auth: {
    username,
    password,
  },
});

export const processAuth = (payload) => ({
  type: PROCESS_AUTH,
  payload,
});

export const authError = (payload) => ({
  type: AUTH_ERROR,
  payload,
});

export const clearRefillStore = (payload) => ({
  type: CLEAR_REFILL_STORE,
  payload,
});
